import { toast } from 'react-toastify';
import './RaceBar.css';
import {
  getAllReaders,
  getDocument,
  updateDocument,
} from '../../../firebase-functions/database';
import { serverTimestamp } from 'firebase/firestore';
import { auth } from '../../../firebase-functions/config';
import { RaceBar } from './RaceBar';

export const RacebarContainer = ({ studentInfo, readerProfile }) => {
  const handleUpdateReadingRaceLogs = () => {
    getDocument('utils', 'racingLogs').then((res) => {
      if (!res.success) return;

      if ((new Date() - new Date(res.data.updatedAt.toDate())) / 60000 < 2) {
        toast.info(
          'It was already updated ' +
            Math.floor(
              (new Date() - new Date(res.data.updatedAt.toDate())) / 60000,
            ) +
            ' minutes ago! Refreshing the page now!',
        );
        setTimeout(() => {
          window.location.reload();
        }, 3000);
        return;
      }
      getAllReaders().then(async (res) => {
        if (!res.success) {
          return;
        }
        const readers = res.message;
        const allEntries = [];
        const lastYearEntries = [];
        for (const reader of readers) {
          const { id, name, performance } = reader;
          if (!performance || performance.length === 0) continue;
          for (const record of performance) {
            const { book, dateRead, stats } = record;

            const wordsRead = book.wordLength || 0;
            const percentile = stats.percentile || 0;
            const gainedXP = wordsRead * percentile;
            const timestamp = dateRead?.toDate ? dateRead.toDate() : new Date();

            if (
              new Date(dateRead.toDate()).getYear() === new Date().getYear()
            ) {
              allEntries.push({
                name,
                avatarSeed: id,
                book: book.title,
                wordsRead,
                percentile,
                gainedXP,
                timestamp,
                league: reader.league,
                readingGroup: reader.collab || false,
              });
            }
          }
        }
        try {
          if (!allEntries?.length) {
            toast.info('No entries to upload');
            return;
          } // Clean up timestamps and remove undefined fields

          //last year ==> allEntries
          const cleanedEntries = allEntries.map((entry) => ({
            ...entry,
            timestamp:
              entry.timestamp?.toDate?.() || entry.timestamp || new Date(), // fallback
          }));
          const data = {
            updatedAt: serverTimestamp(),
            entries: cleanedEntries
              .filter(
                (e) =>
                  ![
                    'David',
                    // "T-Martina",
                    'Alina',
                    'Tee',
                    'Nodd',
                    'Yok',
                    'JM',
                    'JC',
                    'Pan',
                    'Janne',
                    'Phupha',
                    // "T.Baibua",
                  ].includes(e.name),
              )
              .filter((a) => a.avatarSeed != undefined)
              .sort((a, b) => {
                const timeA =
                  a.timestamp?.getTime?.() || a.timestamp?.toMillis?.();
                const timeB =
                  b.timestamp?.getTime?.() || b.timestamp?.toMillis?.();
                return timeA - timeB;
              }),
          };

          updateDocument('utils', 'racingLogs', data, auth?.currentUser).then(
            (res) => {
              if (res?.success) {
                toast.info('Race Entries updated. Refreshing now');
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              } else {
                console.error('Upload failed:', res);
              }
            },
          );
        } catch (error) {
          console.error('Upload failed:', error);
        }
      });
    });
  };

  return (
    <div className='racebar-container'>
      <RaceBar
        studentProfile={studentInfo}
        readerProfile={readerProfile}
        handleUpdateReadingRaceLogs={handleUpdateReadingRaceLogs}
      />
    </div>
  );
};
